// extracted by mini-css-extract-plugin
export var searchResults = "search-module--searchResults--9447d";
export var singleHit = "search-module--singleHit--e4854";